import React from 'react'

type Props = {}

const EntranceExamination = (props: Props) => {
    return (
        <div>EntranceExamination</div>
    )
}

export default EntranceExamination